jQuery( function( $ ){
    var last_click_chain = false;
    var others_map = {};
    var $body = $('body');

    prepareSyncClick( $body );

    function prepareSyncClick( $container ) {
        $container.find('[data-sclick]').each( prepareItems );
    }

    function prepareItems(i,el){
        var sync = $(this).data('sclick');
        others_map[ sync ] = others_map[ sync ] || [];
        others_map[ sync ].push( $(el) );
        var this_index = others_map[sync].length - 1;
        $(el).on('click', function(){
            var max = others_map[sync].length;
            if( last_click_chain === sync ){
                return;
            }
            last_click_chain = sync;
            for( var j = 0; j < max; j ++ ) {
                if( j !== this_index ){
                    others_map[ sync ][ j ].click();
                }
            }
            last_click_chain = false;
        });
    }

    window.synclickPrepare = prepareSyncClick;

});